<!-- Slider-specific properties content ONLY -->
<div class="panel-content">
    <small class="debug">{{ me }}</small>
    <br/>
    <div class="overview-card">
        <div class="overview-stats">
            <div class="stat-item">
                <span class="stat-label">{{ 'ai.totalSlides' | transloco }}</span>
                <span class="stat-value">{{ getPagesLength(renderScene) }}</span>
            </div>
            <div class="stat-item">
                <span class="stat-label">{{ 'ai.resolution' | transloco }}</span>
                <span class="stat-value">{{ sceneWidth }} x {{ sceneHeight }}</span>
            </div>
        </div>
    </div>
    <div class="settings-section">
        <!-- Navigation Buttons -->
        <app-setting-toggle-group
            icon="touch_app"
            title="{{ 'ai.navigationalStyle' | transloco }}"
            name="navigation"
            ariaLabel="Navigation Mode"
            [options]="navigationOptions"
            [hideSingleSelectionIndicator]="false"
            [ngModel]="navigationMode"
            (selectionChange)="onChangeNavigationMode($event)">
        </app-setting-toggle-group>

        <!-- Slider Name -->
        <div class="input-group">
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>{{ 'placeholder.name' | transloco }}</mat-label>
                <input autocomplete="off" inputrestriction="basic1" matInput
                       value="{{renderScene?.Player?.$.label}}"
                       (keyup)="onChangeSceneName($event)"
                       (change)="onChangeSceneName($event)">
                <mat-icon matPrefix>edit</mat-icon>
            </mat-form-field>
        </div>

        <!-- Duration -->
        @if (navigationMode === 'time') {
            <div class="input-group">
                <mat-form-field appearance="outline" class="full-width">
                    <mat-label>{{ 'ai.durationSeconds' | transloco }}</mat-label>
                    <input type="number" matInput [formControl]="durationControl" class="hide-spinners">
                    <mat-icon matPrefix>schedule</mat-icon>
                    <span matSuffix>sec</span>
                </mat-form-field>
            </div>
        }

        <!-- Category (Advanced) -->
        @if (experienceLevel > experienceLevelType.BEGINNER) {
            <div class="input-group">
                <mat-form-field appearance="outline" class="category-field">
                    <mat-label>{{ 'placeholder.category' | transloco }}</mat-label>
                    <input inputrestriction="basic1" matInput value="{{category}}" readonly>
                    <mat-icon matPrefix>folder</mat-icon>
                </mat-form-field>
                <button mat-icon-button class="category-btn" (click)="openCategoryTree()"
                        matTooltip="{{ 'ai.browseCategories' | transloco }}">
                    <mat-icon>folder_open</mat-icon>
                </button>
            </div>
        }
    </div>

    <!-- Debug Info (Advanced) -->
    @if (experienceLevel > experienceLevelType.BEGINNER) {
        <div class="debug-section">
            <h4 class="section-title">
                <mat-icon>bug_report</mat-icon>
                {{ 'ai.debugInfo' | transloco }}
            </h4>
            <div class="debug-info">
                <div class="debug-row">
                    <span class="debug-label">ID:</span>
                    <span class="debug-value">{{ renderScene?.Player?.$.id }}</span>
                </div>
                <div class="debug-row">
                    <span class="debug-label">MIME:</span>
                    <span class="debug-value">{{ renderScene?.Player?.$.mimeType }}</span>
                </div>
                <div class="debug-row">
                    <span class="debug-label">Auto Scale:</span>
                    <span class="debug-value">{{ renderScene?.Player?.$.autoScaling }}</span>
                </div>
                <div class="debug-row">
                    <span class="debug-label">Player Type:</span>
                    <span class="debug-value">{{ renderScene?.Player?.$.player }}</span>
                </div>
            </div>
        </div>
    }
</div>
